var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 2.07c1.41.2 2.78.78 3.94 1.74l-2.5 2.5a7.18 7.18 0 0 1-1.44-4.24ZM10 8.9 4.9 3.81A7.97 7.97 0 0 1 9.6 2a8.7 8.7 0 0 0 1.9 5.41L10 8.91Zm6.19-4a7.95 7.95 0 0 1 1.74 3.95 7.18 7.18 0 0 1-4.24-1.45l2.5-2.5Zm-8.78 6.6A8.73 8.73 0 0 0 2 9.6a7.97 7.97 0 0 1 1.81-4.7l5.1 5.1-1.5 1.5Zm2.59-.4 5.1 5.09A8 8 0 0 1 10.4 18a8.73 8.73 0 0 0-1.9-5.41l1.5-1.5Zm-6.19 4a7.95 7.95 0 0 1-1.74-3.95 7.2 7.2 0 0 1 4.24 1.45l-2.5 2.5Zm8.78-6.6A8.69 8.69 0 0 0 18 10.4a7.97 7.97 0 0 1-1.81 4.7l-5.1-5.1 1.5-1.5Zm-3.74 9.43a7.95 7.95 0 0 1-3.94-1.74l2.5-2.5a7.22 7.22 0 0 1 1.44 4.24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBall);
export default ForwardRef;